<template>
  <v-main>
    <AppBar title="비밀번호 변경" />
    <v-layout fill-height column>
      <v-container flex-fill fluid>

        <v-form ref="submitForm" class="form-item" v-model="valid">
          <label class="label">현재 비밀번호</label>
          <div class="input-group mb-4">
            <v-text-field type="password" solo flat filled clearable required
                          v-model.trim="oldPw"
                          clear-icon="mdi-close-circle"
                          :rules="[chk_password_rule(oldPw)]"
                          placeholder="비밀번호(8~20자 영문, 숫자, 특수문자)"
                          @focusout="onCheckPw"
            >
              <template #append>
                <IconCheckSuccess :class="[ 'primary--text', chk_password_rule(oldPw) === true ? 'd-block' : 'd-none']" />
              </template>
            </v-text-field>
          </div>

          <label class="label">새 비밀번호</label>
          <div class="input-group mb-4">
            <v-text-field type="password" solo flat filled clearable required
                          v-model.trim="newPw"
                          clear-icon="mdi-close-circle"
                          :rules="[new_password_rule(newPw)]"
                          placeholder="8~20자 영문, 숫자, 특수문자"
            >
              <template #append>
                <IconCheckSuccess :class="[ 'primary--text', new_password_rule(newPw) === true ? 'd-block' : 'd-none']" />
              </template>
            </v-text-field>
          </div>

          <label class="label">새 비밀번호 확인</label>
          <div class="input-group">
            <v-text-field type="password" solo flat filled clearable required
                          v-model.trim="confirmPw"
                          clear-icon="mdi-close-circle"
                          :rules="[confirm_password_rule(confirmPw)]"
                          placeholder="비밀번호 재입력"
            >
              <template #append>
                <IconCheckSuccess :class="[ 'primary--text', confirm_password_rule(confirmPw) === true ? 'd-block' : 'd-none']" />
              </template>
            </v-text-field>

          </div>
        </v-form>
      </v-container>
      <v-footer app color="transparent" class="content-footer">
        <div class="footer-btns">
          <v-btn color="primary" class="btn-basic"
                 x-large depressed
                 :disabled="!valid"
                 @click="onSubmit"
          >변경하기
          </v-btn>
        </div>
      </v-footer>
    </v-layout>
  </v-main>
</template>
<script>
import store from '@/store'
import IconCheckSuccess from '@/components/icons/CheckSuccess.vue'
export default {
  components: {
    IconCheckSuccess
  },
  data: () => ({
    valid: false,

    oldPw: null,
    newPw: null,
    confirmPw: null,

    complete: false,
    passwdCheck: -1,

  }),
  watch: {
    oldPw () {
      this.passwdCheck = -1
    }
  },
  methods: {
    chk_password_rule (v) {
      if (v === null || v === '') return `기존 비밀번호를 입력해주세요.`
      if (v && this.passwdCheck === 0) return `기존 비밀번호와 다릅니다.`
      if (v && this.passwdCheck === -1) return false
      if (v && this.passwdCheck === 1) return true
    },
    new_password_rule (v) {
      if (v === null || v === '') return `새 비밀번호를 입력해주세요.`
      if (this.passwdCheck === 1 && v === this.oldPw) return `기존 비밀번호와 동일합니다. 다르게 입력하세요.`
      let str = '', str1 = '', str2 = []
      if (v.length <= 7 || v.length > 20) str1 = '8~20자'
      if (!(/[A-Za-z]/.test(v))) str2.push('영문')
      if (!(/\d/.test(v))) str2.push('숫자')
      if (!(/[^A-Za-z0-9]/.test(v))) str2.push('특수문자')
      str = `${str1} ${str2.join(', ')}`

      if (str2.length === 0 && str1 === '') {
        return true
      } else if (str2.length > 0) {
        return `${str}을(를) 포함하여 입력해주세요.`
      } else {
        return `${str}내로 입력해주세요.`
      }
    },
    confirm_password_rule (v) {
      if (v === null || v === '') return `새 비밀번호를 확인해주세요.`
      if (v !== this.newPw) return `새 비밀번호와 일치하지 않습니다.`
      return true
    },
    onCheckPw() {
      // 기존 비밀번호 확인
      store.dispatch('passwordCheck', this.$_payload('passwdMap', {passwd: encodeURIComponent(this.oldPw)}))
        .then(res => this.passwdCheck = res.data)
        .catch(error => {
          console.error(error);
        })
    },
    onSubmit () {
      const msg = "변경이 완료되었습니다.";
      store.dispatch('setMemberInfoInner', this.$_payload('inData', {password: this.newPw, userKey: store.getters.userKey}))
          .then(res => {
            if (res.success) {
              // 패스워드 변경 유도창에서 요청할 경우
              if (this.$route.query.required * 1 === 1) {
                this.$alert(msg).then(() => window.location.href = "/user")
              }
              else {
                this.$root.$children[0].$refs.toast.toastOpen('top', msg);
                this.prevPage()
              }
            } else {
              this.$alert(res.msg)
            }
          }).catch(error => {
            console.error(error);
          }).finally(() => {})
    }
  }
}
</script>


